const riot = require('riot');

riot.tag2('module-project-editor', '<form onsubmit="{onSubmit}"> <div class="mb24"> <label> <div class="mb8">プロジェクト名</div> <input class="input w-full px12" ref="name" type="text" required> </label> </div> <div class="mb24"> <label> <div class="cursor-pointer pb8">カラー</div> <input class="h50 border rounded-8 p4 cursor-pointer" list="{uniqId}" ref="color" required type="color"> <datalist id="{uniqId}"> <option each="{color in app.data.project.recommend_colors}" riot-value="{color}"></option> </dataList> </label> </div> <div class="mb24"> <div class="lh15 fs12 mb10">稼働時間から除外</div> <div ref="exclusion" data-is="atom-switch"></div> </div> <div class="mb24"> <div class="lh15 fs12 mb10">プロジェクトをアーカイブ</div> <div ref="archived" data-is="atom-switch"></div> </div> <div class="f fr" if="{!app.useragent.isMobile}"> <button class="button high fw4 mr16" type="button" onclick="history.back()">戻る</button> <button class="button primary fw4">{opts.project ? \'保存\' : \'作成\'}</button> </div> </form>', '', '', function(opts) {
    this.uniqId = app.utils.getUniqId();

    this.setup = () => {
      if (this.opts.project) {
        this.refs.name.value = this.opts.project.data.name;

        this.refs.color.value = this.opts.project.data.color || app.utils.defaultColor;

        if (this.opts.project.data.exclusion) {
          this.refs.exclusion.setValue(this.opts.project.data.exclusion);
        }

        if (this.opts.project.data.archived) {
          this.refs.archived.setValue(this.opts.project.data.archived);
        }
      }
      else {
        this.refs.name.value = '';

        this.refs.color.value = app.utils.defaultColor;
      }
      requestAnimationFrame(() => {
        this.refs.name.focus();
      });
    };

    this.onSubmit = async (e) => {
      e.preventDefault();

      var name = this.refs.name.value.trim();
      if (!name) {
        spat.modal.alert('名前が入っていません');
        return;
      }

      var ref = app.store.collection('projects');

      if (this.opts.project) {
        ref = ref.doc(this.opts.project.id);
        await ref.update({
          name: name,

          color: this.refs.color.value,
          exclusion: this.refs.exclusion.getValue(),
          archived: this.refs.archived.getValue(),
          updated_at: Date.now(),
        });
        await ref.refresh();
        this.opts.project = await ref.fetch({ relation: true });
        spat.toast.message('保存しました');
      }
      else {
        var doc = await ref.add({
          name: name,

          color: this.refs.color.value,
          exclusion: this.refs.exclusion.getValue(),
          archived: this.refs.archived.getValue(),
          created_at: Date.now(),
        });
        var project = await app.store.doc(doc.path).fetch({ relation: true });

        spat.toast.message('作成しました');
      }
      spat.router.push('/projects');
      this.trigger('close');
      this.update();
    };

    this.onDummyFunc = (e) => {
      e.preventDefault();
      spat.modal.alert('未実装');
    };
});